module.exports = __webpack_public_path__ + "img/logo-2.82e50eb5.png";